module.exports = __webpack_public_path__ + "img/bg_avatar_male_49.60b2a0aa.png";